// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6f73bac","455":"778f12d8"}[chunkId] + ".chunk.js";
};